module.exports = __webpack_public_path__ + "static/image/main/main_baemin_reset.ver2_0_2.jpg?9e1d20ed";